// OurProductsHome.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import productCardGradients, {
  productCardBoxShadow,
  productCardRadialGradients,
} from '../../../common/Utils/Utils';
import ProductsGridHome from './ProductsGridHome';
import SubmitButton from '../../submitButton/SubmitButton';
import EmptyState from '../../emptyState/EmptyState';

function OurProductsHome({ products = [], user }) {
  const navigate = useNavigate();
  return (
    <div className="container">
      <div className="py-4 py-lg-5 ">
        <div className="position-relative mb-4">
          <h2 className="font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_7 text-black text-center pt-2">
            Our Products
          </h2>
          <h3 className="ourProductPositionhead mb-0 font_600 w-100 text-center">
            Our Products
          </h3>
        </div>
        <p className="font_14 font_400 line_height1_7 text_light1 text-center">
          Discover our suite of cutting-edge OCR products designed to extract
          and verify identity data with speed and precision. <br /> From
          passports to Aadhaar and Emirates ID, streamline your KYC processes
          effortlessly.
        </p>
        {products.length === 0 ? (
          <EmptyState
            style={{ marginTop: 100 }}
            description="Nothing to display"
          />
        ) : (
          <>
            <ProductsGridHome
              products={products}
              productCardGradients={productCardRadialGradients}
              productCardBoxShadow={productCardBoxShadow}
            />
            <div className="d-flex justify-content-center mt-4">
              <SubmitButton
                style={{ marginTop: '0px' }}
                className="mt-0 rounded-pill cursor-pointer"
                onClick={() => navigate('/products')}
                label="View All Products"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(OurProductsHome);
